import { adminFetch } from './dataProvider';

export async function archiveLead(id: string): Promise<void> {
  await adminFetch<void>(`/v1/admin/leads/${id}/archive`, { method: 'POST' });
}

export async function restoreLead(id: string): Promise<void> {
  await adminFetch<void>(`/v1/admin/leads/${id}/restore`, { method: 'POST' });
}
